import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Grid from "@mui/material/Grid";

/**
 * "AI may make mistakes" notice shown beneath the composer. Figma "bottom-dock"
 * (15125:585): Body 3 at a 15px line in Text/Core/Placeholder; the dock's own
 * 8px gap is the only space above it.
 */
export const AiDisclaimer = () => (
  <Grid textAlign={"center"} sx={{ mb: "4px" }}>
    <IgTypography
      variant="body3"
      sx={{ color: "text.placeholder", display: "block", lineHeight: "15px" }}
    >
      Intelligems AI may make mistakes. We recommend verifying information
      shared through this chat.{" "}
    </IgTypography>
  </Grid>
);
